export const CHANGED_PASSWORD = `changedPassword`;
export const COOKIE_KEY_PROMO_SOURCE = `promoSource`;
export const COOKIE_KEY_PREFERRED_PROMO_SOURCE = `preferredPromoSource`;
export const FIRST_LOGIN = `firstLogin`;
export const QUERY_PARAM_AFTER_LOGIN = `afterLogin`;
export const QUERY_PARAM_CAMPAIGN_DATA = `d`;
export const QUERY_PARAM_CAMPAIGN_KEY = `k`;
export const QUERY_PARAM_PAID_APPLICATIONS = `paid`;
export const QUERY_PARAM_PAYMENT_FAILURE = `failure`;
export const QUERY_PARAM_PAYMENT_RESULT = `paymentResult`;
export const QUERY_PARAM_PAYMENT_SUCCESS = `success`;
export const QUERY_PARAM_PROMO_SOURCE = `promo`;
export const QUERY_PARAM_INTERNAL_SOURCE = 'source';
export const QUERY_PARAM_TOKEN_EXPIRED = `tokenExpired`;
export const QUERY_PARAM_NEW_TAB = `newTab`;
export const QUERY_DEFERRED_PAYMENT_MINI_REVOLVING_PREFERENCE = `deferred_payment_mini_revolving_preference`;
export const STORAGE_KEY_BENEFIT_BOX = 'benefitBox';
export const STORAGE_KEY_COOKIES_SETTINGS = `cookies_settings`;
export const STORAGE_KEY_AVAILABLE_REVOLVING_APPLICATION_VIEWED = `available_revolving_application_viewed`;
export const STORAGE_KEY_PROCESSING_REVOLVING_APPLICATION_VIEWED = `processing_revolving_application_viewed`;
export const STORAGE_KEY_SIMPLE_ID_MOBILE_DEVICE = `simpleIdMobileDevice`;
export const STORAGE_KEY_REWARDS_FILTER = `rewardsFilter`;
export const STORAGE_KEY_REWARDS_SORT = `rewardsSort`;
export const STORAGE_KEY_IGNORE_LIMIT_AMENDMENT_BEFORE_KYC = 'ignoreLimitAmendmentBeforeKyc';
export const STORAGE_KEY_DISABLE_SCREEN_SECURITY_LOCK = 'disableScreenSecurityLock';
export const STORAGE_KEY_PERSIST_APOLLO_CACHE = 'persistApolloCache';
export const STORAGE_KEY_EXPERIMENTAL_EXTERNAL_REDIRECT = 'experimentalExternalRedirect';
export const CAPACITOR_DEVICE_ID = `_capuid`;

// Device signature is used to identify the device in the context of device change. It is used to identify when the device has changed and the user should be logged out for security reasons.
// It's normalized with normalizeDeviceUuid function. Stored secured. This signature should not be deleted when the user logs out.
export const DEVICE_SIGNATURE = 'deviceSignature';
